// fonts
export const HIRAGINO_FONT =
  '-apple-system, "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Meiryo", "メイリオ", "Helvetica", "MS PGothic", arial, sans-serif';

// colors
export const MAIL_BASE = '#db4437';
// Facebook
export const FB_BASE = '#4267B2';
// LINE
export const LINE_BASE = '#00C300';
export const LINE_HOVER = '#00E000';
export const LINE_PRESS = '#00B300';
// 小田急
export const ONE_ODAKYU_BASE = '#0082cd';
